<template>
    <div class="tracking-script">
        <form-textarea rows="6" :label="label" v-model="scriptText" :readonly="isConfiguredGA" />
        <b-alert v-if="isConfiguredGADeprecated" show variant="warning">
            Support for Google Universal Analytics will end in 2023. Please migrate your UA tracking id to a Google
            Analytics 4 tracking id by the end of June of 2023.
        </b-alert>
        <div class="tracking-buttons">
            <div v-if="!isConfiguredGA">
                <form-checkbox class="mb-0 tracking-header-button" v-model="headerSwitch">
                    Insert tracking script in Header
                </form-checkbox>
            </div>
            <div v-if="!isConfiguredGA">
                <b-button
                    @click="$bvModal.show('setup-ga-cross-domain-tracking-modal')"
                    class="setup-cross-domain-button"
                    variant="default"
                >
                    Setup GA Cross Domain Tracking
                </b-button>
            </div>
            <div v-if="isConfiguredGA">
                <b-button
                    @click="$bvModal.show('disable-ga-cross-domain-tracking-modal')"
                    class="disable-cross-domain-button"
                    variant="default"
                >
                    Disable GA Cross Domain Tracking
                </b-button>
            </div>
        </div>
        <modal
            id="disable-ga-cross-domain-tracking-modal"
            title="Disable GA"
            @ok="$emit('disable-cross-domain-tracking')"
        >
            Are you sure want to reset disable Google Analytics Cross Domain tracking?
        </modal>
        <validation-observer v-slot="{ meta, setFieldValue }">
            <modal
                id="setup-ga-cross-domain-tracking-modal"
                title="Google Analytics"
                @hidden="currentGAId = ''"
                @ok="$emit('setup-cross-domain-tracking', currentGAId)"
                :ok-disabled="!meta.valid"
                @shown="setValues({ ga_tracking_id: currentGAId })"
            >
                <div>Configure Google Analytics Cross Domain Tracking</div>
                <br />
                <div>
                    <validation-provider
                        name="ga_tracking_id"
                        v-slot="{ errors }"
                        rules="required|validGoogleTrackingID"
                    >
                        <form-input
                            floating-label="GA Tracking Code"
                            v-model="currentGAId"
                            :error="errors.ga_tracking_id"
                            @input="(val) => setFieldValue('ga_tracking_id', val)"
                        />
                    </validation-provider>
                </div>
            </modal>
        </validation-observer>
    </div>
</template>

<script>
    import FormCheckbox from '../generic/form-checkbox/form-checkbox.vue';
    import FormInput from '../generic/form-input/form-input.vue';
    import FormSquareSwitch from '../generic/form-square-switch/form-square-switch.vue';
    import FormTextarea from '../generic/form-textarea/form-textarea.vue';
    import Modal from '../generic/modal/modal.vue';

    export default {
        components: { FormCheckbox, FormInput, FormSquareSwitch, FormTextarea, Modal },
        props: {
            trackingScripts: {
                type: String,
                required: true,
            },
            trackingHeader: {
                type: Boolean,
                required: true,
            },
            label: {
                type: String,
                default: '',
            },
            gaTrackingId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                currentGAId: '',
            };
        },
        computed: {
            scriptText: {
                get() {
                    return this.trackingScripts;
                },
                set(value) {
                    this.$emit('input-tracking-scripts', value);
                },
            },
            headerSwitch: {
                get() {
                    return this.trackingHeader;
                },
                set(value) {
                    this.$emit('change-tracking-header', value);
                },
            },
            isConfiguredGA() {
                return !!this.gaTrackingId;
            },
            isConfiguredGADeprecated() {
                return this.gaTrackingId.startsWith('UA');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tracking-script {
        .tracking-buttons {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-top: -1rem;
            & > * {
                margin-top: 1rem;
            }
        }
    }
</style>
